import {
  FETCH_ALL_CONST_CENTERS,
  ADD_CONST_CENTERS,
  FETCH_COST_CENTERS_BY_ID,
  UPDATE_CONST_CENTERS,
  DELETE_CONST_CENTERS,
  FETCH_ALL_CONST_CENTERS_COMPANY,
  START_LOADING,
  END_LOADING,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  costcenters: [],
  costcentersById: null,
  costcentersCompany: [],
};

const costcenters = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ALL_CONST_CENTERS:
      return {
        ...state,
        costcenters: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_COST_CENTERS_BY_ID:
      return { ...state, costcentersById: action.payload };
    case ADD_CONST_CENTERS:
      return {
        ...state,
        costcenters: [...state.costcenters, action.payload],
      };
    case UPDATE_CONST_CENTERS:
      return {
        ...state,
        costcenters: state.costcenters.map((costcenter) =>
          costcenter._id === action.payload._id ? action.payload : costcenter
        ),
      };
    case FETCH_ALL_CONST_CENTERS_COMPANY:
      return { ...state, costcentersCompany: action.payload };

    case DELETE_CONST_CENTERS:
      return {
        ...state,
        costcenters: state.costcenters.filter(
          (costcenter) => costcenter._id !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default costcenters;
